import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';
import { STOCK_STATUS } from '../../../commons/utils';

const Theme = Common.Theme;

export const RootContainer = styled(Common.RootContainer)``;

export const FlexRow = styled(Common.FlexRow)``;

export const FlexColumn = styled(Common.FlexColumn)``;

export const TitleSection = styled(Common.TitleSection)``;

export const Title = styled(Common.Title)``;

export const TitleRow = styled(Common.TitleRow)``;

export const SubtitleSection = styled(Common.SubtitleSection)``;

export const SubtitleRow = styled(Common.SubtitleRow)``;

export const Subtitle = styled(Common.Subtitle)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Search = styled(Common.Search)``;

export const Popover = styled(Common.Popover)``;

export const PopoverBody = styled(Common.PopoverBody)``;

export const PopoverItem = styled(Common.PopoverItem)``;

export const PopoverTitle = styled(Common.PopoverTitle)``;

export const CircularProgress = styled(Common.CircularProgress)``;

export const NotFound = styled(Common.NotFound)``;

export const Button = styled(Common.Button)``;

export const CircularButton = styled(Common.CircularButton)``;

export const SquareButton = styled(Common.SquareButton)``;

export const FilterButton = styled(Common.Button)`
	color: ${Theme.black} !important;
`;

export const ProductImage = styled.img`
	display: block;
	max-height: 3rem;
	max-width: 3rem;
`;

export const TableContainer = styled(Common.TableContainer)`
	margin-top: 0rem;
`;

export const Table = styled(Common.Table)``;

export const TableHeader = styled(Common.TableHeader)``;

export const TableHeaderRow = styled(Common.TableHeaderRow)``;

export const TableHeaderColumn = styled(Common.TableHeaderColumn)``;

export const TableBody = styled(Common.TableBody)``;

export const TableRow = styled(Common.TableRow)``;

export const TableColumn = styled(Common.TableColumn)``;

export const CloneHeaderColumn = styled(TableHeaderColumn)`
	padding: 0.45rem 0 !important;
`;

export const PriceHeaderColumn = styled.div`
	width: 9rem !important;
	min-width: 9rem !important;
	cursor: pointer;
`;

export const PriceColumn = styled.div`
	width: 9rem !important;
	min-width: 9rem !important;
`;

export const PriceGroup = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`;

export const TablePagination = styled(Common.TablePagination)``;

export const Price = styled(Common.Price)``;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DatePicker = styled(Common.DatePicker)``;

export const StockStatusColumn = styled(FlexRow)`
	cursor: ${(props) => props.disabled ? "not-allowed" : "pointer"};
	display: inline-flex;
	padding-top: 0.5rem;
	color: ${(props) =>
		props.status === STOCK_STATUS.IN_STOCK ? Theme.green : props.status === STOCK_STATUS.OUT_OF_STOCK ? Theme.red : props.status === STOCK_STATUS.BACKORDER ? Theme.blue : Theme.black};
`;

export const Note = styled(Common.Note)``;